import { Component, Input, Renderer } from '@angular/core';
import { AuthUtil } from '../../../../utils/auth.utils';
import { Router } from '@angular/router';
import { CreateSignatureDialogContractStateService } from './signature.modal.state.service';
import { DocumentsHttpService } from '../../../../services/documents/documents.http.service';
import { StorageUtil } from '../../../../utils/storage.util';
import { ContractsHttpUtil } from '../contracts.util';

const CryptoPro = require('crypto-pro');
import * as JSZip from 'jszip';
import {CommunicationsHttpUtil} from '../../communications/communications.util';
import { CommunicationsHttpService } from '../../../../services/communications/communications.http.service';

@Component({
  moduleId: module.id,
  selector: 'bft-signature-modal-contract',
  templateUrl: 'signature.modal.component.html',
  styleUrls: ['signature.modal.component.css'],
  providers: []
})

export class SignatureModalComponent {
  @Input()
  lawInstanceId;

  model: any = null;
  displayDialog: boolean = false;
  isPluginEnabled: boolean = false;
  isNotPlugin: boolean = false;
  plugin: object = {
      cadesVersion: '0.0.0',
      cspVersion: '0.0.0'
  };
  certList: any = null;
  selectCert: any = null;
  certListOptions = [];
  cert = {};
  Now = null;
  attach = null;


  constructor(private documentsHttpService: DocumentsHttpService,
              private createSignatureDialogService: CreateSignatureDialogContractStateService,
              private authUtil: AuthUtil,
              private router: Router,
              private renderer: Renderer,
              private communicationHttpService: CommunicationsHttpService
  ) {
      this.createSignatureDialogService.handleDialogStatus().subscribe(data => {
          this.displayDialog = data.display;
          this.attach = data.attach;
          this.model = data.model;

          if (this.displayDialog) {
              this.loadingPlugin();
          } else {
              this.isPluginEnabled = false;
          }
      });
  }

  loadingPlugin() {
      const self = this;
      CryptoPro.call('getSystemInfo').then(function(data) {
          self.isPluginEnabled = true;
          self.plugin = data;

          CryptoPro.call('getCertsList').then(function(certs) {
              console.log(certs);
              self.certList = certs;
              self.certList.map(function(cert) {
                  self.certListOptions.push({value: cert, label: cert['label']});
              });
          });
      }, function(error) {
          self.isNotPlugin = true;
      });
  }

  changeCurrentCert($event) {

        this.Now = new Date();
        this.cert = {
            'owner': $event.value.subjectName,
            'issuer': $event.value.issuerName.split(', ')[0],
            'start': $event.value.validFrom,
            'end': $event.value.validTo,
            'startDate': new Date($event.value.validFrom),
            'endDate': new Date($event.value.validTo),
            'status': 'проверка...'
        };

        const self = this;
        $event.value.getAlgorithm().then(function(result) {
            self.cert['algoritm'] = result.algorithm;
        });

        $event.value.getProp('PrivateKey').then(function(result) {
            result.ProviderName.then(function(resultPN) {
                self.cert['privKey'] = resultPN;

                if(self.Now < self.cert['startDate']) {
                    self.cert['status'] = "Срок действия не наступил";
                } else if(self.Now > self.cert['endDate']) {
                    self.cert['status'] = "Срок действия истек";
                } else if( !self.cert['privKey'] ) {
                    self.cert['status'] = "Нет привязки к закрытому ключу";
                } else {
                    self.cert['status'] = "Действителен";
                }
            }, function() {
                self.cert['status'] = 'Не удалось проверить';
            });
        });
  }

  signFile($event) {
      let data = {
          securityToken: StorageUtil.getToken(),
      };

      let self = this;
      let requestParams = ContractsHttpUtil.prepareParamsDownload(data);

      let type = null;
      this.documentsHttpService.getDocument(requestParams, this.attach.id)
          .map(res => {
              if(res.headers.get('content-disposition')) {
                  return res.blob();
              }
          })
          .subscribe(blobContent => {
                  if(blobContent) {
                      var reader = new FileReader();
                      reader.readAsDataURL(blobContent);
                      reader.onloadend = function() {

                          let resultReader = reader.result.split(',');
                          type = resultReader[0];

                          let contentType = 'application/pdf';
                          if(self.attach.name.split('.').pop() === 'docx') {
                              CryptoPro.call('signData', self.selectCert.thumbprint, resultReader[1], true).then(function (result) {
                                  var zip = new JSZip();
                                  var folder = zip.folder(".");
                                  folder.file(self.attach.name, resultReader[1], {base64: true});
                                  folder.file('signature.p7b', result, {base64: true});
                                  zip.generateAsync({type: "blob"}).then(function(content) {
                                      let zipName = self.attach.name.replace('\.docx', '');
                                      self.sendDoc(zipName + "_signed.zip", content);
                                  });
                              }, function (error) {
                                  console.log('error', error);
                              });
                          } else {
                              CryptoPro.call('signData', self.selectCert.thumbprint, resultReader[1], false).then(function (result) {
                                  self.sendDoc(self.attach.name, self.b64toBlob(result, contentType));
                              }, function (error) {
                                  console.log('error', error);
                              });
                          }
                      }

                      // saveAs(blobContent, this.attach.name);
                  } else {
                  }
              },
              error => {

              },
              () => {

              });
  }

  b64toBlob(base64Data, contentType) {
      var sliceSize = 1024;
      var byteCharacters = atob(base64Data);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);

      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
          var begin = sliceIndex * sliceSize;
          var end = Math.min(begin + sliceSize, bytesLength);

          var bytes = new Array(end - begin);
          for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
              bytes[i] = byteCharacters[offset].charCodeAt(0);
          }
          byteArrays[sliceIndex] = new Uint8Array(bytes);
      }


      return new Blob(byteArrays, {type: contentType});
  }

  sendDoc(fileName, blob) {
      let data = {
          securityToken: StorageUtil.getToken(),
          chatType: 1,
          chatTheme: 'Подписанный файл '+ fileName,
          chatMessage: 'Подписанный файл во вложении',
          lawInstanceId: this.model.id,
          attachment: new File([blob], fileName),
      };

      let requestParams = CommunicationsHttpUtil.prepareParamsCreateDialog(data);
      this.communicationHttpService.createChat(requestParams).subscribe(
          success => {
              if (success) {
                  this.router.navigate(['communications']);
                  this.displayDialog = false;
              }
          },
          error => {

          },
          () => {

          });
  }

  close($event) {
    $event.preventDefault();
    this.displayDialog = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/signature/signature.modal.component.ts